export function Public({ state, payload, action }) {
  switch (action) {
    case 'SET':
      window.document.title = payload.appName;
      return { ...state, Public: payload };
    default:
      return { ...state };
  }
}
